<template>
    <modal :show.sync=is_visible modalClasses="modal-hide-footer">
        <LoanInformation :loan_information="_gHlp.getValue(creditReport,'credit_report_summary.commitments',[])" id="card_loan_information" :is_full="true"/>
    </modal>
</template>
<script>
import LoanInformation from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/LoanInformation'
import { mapState, mapActions } from 'pinia';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
    components: {
			LoanInformation
    },
    data() {
        return {
					creditReport:{},
					is_visible: false
        }
    },
		computed: {
			...mapState(useCreditReportStore, ['activeCreditReport']),
		},
		watch: {
			activeCreditReport: {
				handler(newVal) {
					if (!_gHlp.isEmpty(newVal)) {
						this.creditReport = newVal
					}
				}
			},
		},
		methods: {
			show() {
				this.is_visible = true
			},
		},
}
</script>